import { PageRequest } from "@shared/dtos/requests/pageRequest.dto"
import { HisCheckResponse, PatientResponse } from "@shared/dtos/responses/commonResponses.dto"
import { DeepLinkResponse } from "@shared/dtos/responses/deepLinkResponses.dto"
import {
  PatientHistoryPageResponse,
  PatientRegistrationRequestResponse,
  PatientWithDuplicatesPageResponse,
} from "@shared/dtos/responses/patientResponses.dto"
import { PatientAccountsOverviewResponse } from "@shared/zod/schemas/responses/patientAccount"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const findAll = (query?: PageRequest): Promise<PatientWithDuplicatesPageResponse> => {
  return axiosAuth({
    url: "/patients",
    method: "get",
    params: query,
  }).then((resp) => resp.data)
}

export const get = (id: string): Promise<PatientResponse> => {
  return axiosAuth({
    url: `/patients/${id}`,
    method: "get",
  }).then((resp) => resp.data)
}

export const history = (query: PageRequest): Promise<PatientHistoryPageResponse> => {
  return axiosAuth({
    url: "/patients/history",
    method: "get",
    params: query,
  }).then((resp) => resp.data)
}

export const hisCheck = (id: string): Promise<HisCheckResponse> => {
  return axiosAuth({
    url: `/patients/${id}/hischeck`,
    method: "get",
  }).then((resp) => resp.data)
}

export const remove = (id: string): Promise<void> => {
  return axiosAuth({
    url: `/patients/${id}`,
    method: "delete",
  }).then(() => undefined)
}

export const reregister = async (id: string, forceHisUnknown: boolean): Promise<void> => {
  await axiosAuth({
    url: `/patients/${id}/reregister`,
    method: "post",
    params: {
      forceHisUnknown,
    },
  })
  return undefined
}

export const getRegistrationRequestData = (id: string): Promise<PatientRegistrationRequestResponse> => {
  return axiosAuth({
    url: `/patients/${id}/registrationrequest`,
    method: "get",
  }).then((resp) => resp.data)
}

export const getDeepLinks = (id: string): Promise<DeepLinkResponse[]> => {
  return axiosAuth({
    url: `/patients/${id}/deeplinks`,
    method: "get",
  }).then((resp) => resp.data)
}

export const getAccounts = (id: string): Promise<PatientAccountsOverviewResponse> => {
  return axiosAuth({
    url: `/patients/${id}/accounts`,
    method: "get",
  }).then((resp) => resp.data)
}
